// app/javascript/controllers/zoom_controller.js
import { Controller } from "stimulus"
import mediumZoom from 'medium-zoom';

export default class extends Controller {
  static targets = ["zoomable"]

  connect() {
    if (typeof mediumZoom === 'function') {
      mediumZoom(this.zoomableTargets, {
        margin: 22,
        // Прозрачность/размытие задаём через CSS (.medium-zoom-overlay),
        // поэтому не задаём background тут (иначе библиотека выставит inline-стиль).
        scrollOffset: 10,
        // container: '#test_img'
      })
    } else {
      console.error("mediumZoom is not defined as a function")
    }
  }
}
